interface ProgressBarProps {
    currentStep: number
    totalSteps: number
}

export const ProgressBar = ({ currentStep, totalSteps }: ProgressBarProps) => {
    const progress = (currentStep / totalSteps) * 100

    return (
        <div className="my-6 md:mt-0">
            <div className="w-full bg-gray-400 h-1.5 rounded-full overflow-hidden">
                <div
                    className="h-full bg-red-500 transition-all duration-500 ease-out"
                    style={{ width: `${progress}%` }}
                />
            </div>
            <div className="text-center mt-3 text-xs">
                Step {currentStep} of {totalSteps}
            </div>
        </div>
    )
}
